import { Injectable } from "@angular/core";
import { App } from "@capacitor/app";
import { Device } from "@capacitor/device";
import { ToastController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { ProfileModel } from "src/app/models/profile.model";
import { appConfig } from "src/environments/environment";

@Injectable({
  providedIn: "root"
})
export class UtilsService {

  context:any;
  constructor(private translateService: TranslateService, private toastCtrl: ToastController) {

  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  
  deepEqual(object1, object2) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (const key of keys1) {
      const val1 = object1[key];
      const val2 = object2[key];
      const areObjects = this.isObject(val1) && this.isObject(val2);
      if (
        areObjects && !this.deepEqual(val1, val2) ||
        !areObjects && val1 !== val2
      ) {
        return false;
      }
    }
    return true;
  }
  isObject(object) {
    return object != null && typeof object === 'object';
  }

  firstLetterToUpperCase(input:string):string{
    if(input){
      return input.charAt(0).toUpperCase() + input.slice(1);
    }
    else{
      return '';
    }
  }

  cleanName(profile:ProfileModel,lastname:boolean, firstname:boolean){
    let name = '';
    if(profile.details && profile.details.fullDetails && (profile.details.fullDetails.lastname || profile.details.fullDetails.firstname)){
      if(lastname && profile.details.fullDetails.lastname){
        name += profile.details.fullDetails.lastname.toUpperCase().slice(0,15);
      }
      if(lastname && firstname){
        name += " ";
      }
      if(firstname && profile.details.fullDetails.firstname){
        name += this.firstLetterToUpperCase(profile.details.fullDetails.firstname).slice(0,15);
      }      
    }
    else if(profile.details && profile.details.fullDetails && profile.details.fullDetails.email && lastname){ // when only the firstname is displayed, an empty string is returned to avoid displaying twice the email address
      name = profile.details.fullDetails.email;
    }
    else{
      name = 'anonymous';
    }
    return name;
  }

  async getAppInfo(){
    if(!this.context){
      const deviceInfo = await Device.getInfo();
      // console.log(deviceInfo);
      const platform = deviceInfo.platform;
      const onMobileApp = platform == "ios" || platform == "android";
      let appVersion = '';
      if(onMobileApp){
        const appInfo = await App.getInfo();
        appVersion = appInfo.version
      }
      else{
        appVersion = appConfig.version
      }
      this.context = {
        platform:platform,appVersion:appVersion
      }
    }
    return this.context;
  }

  arrayToList(array:string[]):string{
    if( array.length == 1) return array[0]
    return array.slice(0,-1).join(', ') + " " + this.translateService.instant("common.and") + " " + array.slice(-1)
  }

  async presentToast(message: string): Promise<void> {
    const toast = await this.toastCtrl.create({
      message,
      duration: 15000,
      buttons: [
        {
          side: "end",
          icon: "close-circle-outline",
          role: "cancel",
          handler: () => {
            console.log("dismiss toast");
            // toast.dismiss();
          }
        }
      ],
      position: "middle"
    });
    toast.present();
  }
}
